<div class="d-flex flex-column align-items-center text-center">
    <div>{{ 'checkMailbox' | translate }}</div>
    <div>{{ 'followResetPasswordLink' | translate }}</div>
    <div class="py-3">
        <button type="button" class="btn btn_black" (click)="quit()">
            {{ 'backToLogin' | translate }}
        </button>
    </div>
</div>
